package com.swetdot.swetgram.data.cache

import app.cash.sqldelight.db.SqlDriver
import com.swetdot.swetgram.cache.SwetgramCache
import kotlin.js.Promise
import kotlinx.coroutines.await

// The asm build keeps the existing synchronous SQLDelight repositories intact.
// SQLite is held in memory for this tab; server reconciliation restores data after reload.
@JsModule("sql.js/dist/sql-asm.js")
@JsNonModule
private external fun initializeSqlite(): Promise<dynamic>

actual class DatabaseDriverFactory(private val driver: SqlDriver) {
    actual fun create(): SqlDriver = driver
}

suspend fun createBrowserDatabase(): DatabaseDriverFactory {
    val sqlite = initializeSqlite().await()
    val database: dynamic = js("new sqlite.Database()")
    val driver = BrowserSqlDriver(database)
    SwetgramCache.Schema.create(driver).value
    return DatabaseDriverFactory(driver)
}
